<template>
  <v-container fluid grid-list-md pa-0>
    <v-layout row wrap>
      <v-flex xs12 md8>
        <v-layout row wrap>
          <v-flex>
            <AnalysisChart v-if="Object.keys(activeFilter).length" :plantId="getSelectedPlantId" :selectedId="selectedCard"
              :activeFilter="activeFilter"
              @selectedTab="selectedTabHandler" @sideCardData="sideCardData"
              @totalCardData="totalCardData" :callSummaryApi="callSummaryApi" />
          </v-flex>
          <v-flex>
            <AnalysisTotalLossCard :totalCard="totalCard" />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 child-flex>
        <AnalysisSideCard :active="tab" :dateFrom="dates[0]" :dateTo="dates[1]" :cardData="sideCard" @cardSelected="cardSelectedHandler"
          :reset="getSelectedPlantId" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash'
import momentTz from 'moment-timezone'
import {
  mapGetters
} from 'vuex'
import IEcharts from 'vue-echarts-v3/src/full.js'
import AnalysisSideCard from '@/components/downTimeAnalysis/AnalysisSideCard'
import AnalysisTotalLossCard from '@/components/downTimeAnalysis/AnalysisTotalLossCard'
import AnalysisChart from '@/components/downTimeAnalysis/AnalysisChart'

export default {
  components: {
    IEcharts,
    AnalysisSideCard,
    AnalysisTotalLossCard,
    AnalysisChart
  },
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      tab: '',
      totalCard: {},
      sideCard: [],
      selectedCard: '',
      callSummaryApi: 0,
      filter: [
        {
          id: "deviceType",
          type: "select",
          title: "Select device type",
          value: [
            { text: "Grid", value: "grid_down" },
            { text: "Inverter", value: "inv_down" },
          ],
        },
        {
          id: "selectedRange",
          type: "select",
          title: "Choose Date Range",
          value: [
            {
              interval: "daily",
              startOffset: 1,
              endOffset: 1,
              format: "minute",
              text: "Yesterday",
            },
            {
              interval: "daily",
              startOffset: 2,
              endOffset: 0,
              format: "daily",
              text: "Last 3 days",
            },
            {
              interval: "daily",
              startOffset: 6,
              endOffset: 0,
              format: "daily",
              text: "Last 7 days",
            },
            {
              interval: "daily",
              startOffset: 29,
              endOffset: 0,
              format: "daily",
              text: "Last 30 days",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 0,
              endOffset: 0,
              format: "daily",
              text: "Present month",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 1,
              endOffset: 1,
              format: "daily",
              text: "Previous month",
            },
            {
              interval: "monthly",
              offsetLevel: "month",
              startOffset: 2,
              endOffset: 0,
              format: "monthly",
              text: "Last 3 months",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 0,
              endOffset: 0,
              format: "monthly",
              text: "Present Year",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 1,
              endOffset: 1,
              format: "monthly",
              text: "Previous Year",
            },
            {
              interval: "custom",
              text: "Custom",
            },
          ],
        },
        {
          ref: "selectedRange",
          id: "Date",
          type: "datePicker",
          title: "Select Date Range",
          condition: (ref) => {
            if (ref.text === "Custom") {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
      activeFilter: {}
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantTimezone']),
    dates() {
      return this.activeFilter.Date ? [ this.activeFilter.Date.from, this.activeFilter.Date.to ] : ['', '']
    }
  },
  mounted() {
    const yesterday = momentTz().tz(this.getActivePlantTimezone).subtract(1, 'day').format('YYYY-MM-DD')
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if ((child.condition && (!!child.considerStateAlways || child.condition(Obj[child.ref]))) || !child.condition) {
        if (child.type === 'select') {
          if (typeof child.value === 'function') {
            Obj[child.id] = child.value(Obj[child.ref])
          } else {
            Obj[child.id] = child.value[0]
          }
        } else if (child.type === 'datePicker' || child.type === 'singleDatePicker') {
          let parameters = ['from', 'to']
          parameters.forEach(key => {
            if (!Obj[child.id]) { Obj[child.id] = {} }
            Obj[child.id][key] = yesterday
          })
        } else {
          Obj[child.id] = child.value
        }
      }
    })
    this.activeFilter = Obj;
    this.$emit("max:date", yesterday)
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)
  },
  methods: {
    selectedTabHandler(val) {
      this.tab = val
    },
    totalCardData(val) {
      this.totalCard = _.cloneDeep(val)
    },
    sideCardData(val) {
      this.sideCard = [...val]
    },
    cardSelectedHandler(payload) {
      this.selectedCard = payload.id
      this.callSummaryApi = payload.componentHasBeenReset
    }
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    getSelectedPlantId() {
      const yesterday = momentTz().tz(this.getActivePlantTimezone).subtract(1, 'day').format('YYYY-MM-DD')
      const Obj = {}
      const cloneFilterOption = _.cloneDeep(this.filter);
      cloneFilterOption.forEach(child => {
        if ((child.condition && (!!child.considerStateAlways || child.condition(Obj[child.ref]))) || !child.condition) {
          if (child.type === 'select') {
            if (typeof child.value === 'function') {
              Obj[child.id] = child.value(Obj[child.ref])
            } else {
              Obj[child.id] = child.value[0]
            }
          } else if (child.type === 'datePicker' || child.type === 'singleDatePicker') {
            let parameters = ['from', 'to']
            parameters.forEach(key => {
              if (!Obj[child.id]) { Obj[child.id] = {} }
              Obj[child.id][key] = yesterday
            })
          } else {
            Obj[child.id] = child.value
          }
        }
      })
      this.activeFilter = Obj;
      this.$emit("max:date", yesterday)
      this.$emit("filter:config", cloneFilterOption);
      this.$emit('initial:active_filter', Obj)
    }
  }
}
</script>
